exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-light .navbar-toggler{border:0}\n", ""]);

// exports
